
import { css } from 'lit';
export default css`
.aside-list{
  border-top:var(--purple-medium-neutral) 2px solid;
}

.aside-list--heading{
  font-family:var(--ff-inter);
  font-size:var(--fs-sm);
  font-weight:var(--fw-medium);
  padding-top:var(--spacing-5);
}

@media (min-width: 992px){

.aside-list--heading{
    padding-top:var(--spacing-6);
    font-size:var(--fs-lg)
}
  }`;